import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const {
  mlbGrey4
} = COLORS;

export const PlayStatusWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  position: relative;
  svg {
    display: inline-block;
    &:last-child {
      margin-left: 7px;
      padding-bottom: 7px;
    }
  }
`;

export const OutsWrapper = styled.div`
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  color: var(--gameday-play-outs-color);
  position: absolute;
  bottom: 5px;
  left: 40px;
  text-transform: uppercase;
  ${({ isPlayEvent }) => isPlayEvent ? `
    left: 0px;
    top: 2px;
  ` : ''}
`;

export const BaseRunnerText = styled.div`
  display: inline-block;
  font-size: 14px;
  color: var(--gameday-play-outs-color);
  font-weight: bold;
  vertical-align: top;
  padding-top: 2px;
  margin-left: 22px;
  width: calc(100% - 55px);
`;
